import { FelaCSS, colors } from '@bridebook/ui/src';

interface IStyles {
  wrapper: FelaCSS;
  headingWrapper: FelaCSS;
  heading: FelaCSS;
  subHeading: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    marginTop: '40px',
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    paddingBottom: 'calc(175px + env(safe-area-inset-bottom))',
  },

  headingWrapper: {
    paddingHorizontal: 4,
    gap: 16,
  },

  heading: {
    fontDefaultSemiBold: 24,
    lineHeight: '29px',
    color: colors.space,
    flexShrink: 0,
    maxWidthMobile: {
      fontDefault: 16,
      lineHeight: '24px',
    },
  },

  subHeading: {
    fontDefault: 16,
    color: colors.silver,
    flexShrink: 0,
  },
};

export default styles;
